import { cn } from '@core/utils';

import type { HTMLTagProps } from '../../../../types';

type BottomDrawerContentsProps = HTMLTagProps<'div'>;

export const Contents = ({
  className,
  ...restProps
}: BottomDrawerContentsProps) => {
  return (
    <div
      {...restProps}
      className={cn(
        'relative mx-20 mb-16 box-border max-w-full flex-1 overflow-auto hide-scrollbar webkit-scroll-touch',
        className,
      )}
    />
  );
};
